export default __webpack_public_path__ + "static/media/profileReviews.ff653a89.png";